export default __webpack_public_path__ + "static/media/icon-user.a3867c46.svg";